import { AdvancedDraftingValidationStates } from "constants/draftingAttributes";
import { ExportSites } from "constants/exportSites";
import { getAuctionsPlusValidationErrorsOrStatus } from "lib/validation/auctionsPlusValidation";
import { getStockliveValidationErrorsOrStatus } from "lib/validation/stockLiveValidation";

const defaultStatus = () => AdvancedDraftingValidationStates.SUCCESS;

export const ExportSiteValidationErrorOrStatusGetter = {
  [ExportSites.AUCTIONS_PLUS]: getAuctionsPlusValidationErrorsOrStatus,
  [ExportSites.ANGUS_AUSTRALIA]: defaultStatus,
  [ExportSites.STOCK_LIVE]: getStockliveValidationErrorsOrStatus,
  [ExportSites.AGRINOUS]: defaultStatus,
  [ExportSites.LIST_2_SELL]: defaultStatus,
  [ExportSites.FARMGATE]: defaultStatus,
  [ExportSites.THE_HERD]: defaultStatus,
};
